import React from 'react';
import styled from 'styled-components';
import { Grid } from '@mui/material'
import { Container } from '@mui/system'
import { LayoutLoggedArea } from '../../components/Common/LayoutLoggedArea'
import { FormCodeRescue } from '../../components/Coupon/FormCodeRescue';
import { CouponsTable } from '../../components/Coupon/CouponsTable';
import { Title } from '../../components/Common/Title';

const CouponContainer = styled.section`
  padding: 2rem 0;
`;

export const Coupon = () => {
  return (
    <LayoutLoggedArea>
      <CouponContainer>
        <Container>
          <Grid container spacing={0}>
            <Grid item sm={12} xs={12}>
              <Title>Resgate seu código</Title>
            </Grid>
            <FormCodeRescue />
            <Grid item sm={12} xs={12} mt={2}>
              <CouponsTable />
            </Grid>
        </Grid>
        </Container>
      </CouponContainer>
    </LayoutLoggedArea>
  )
}
